import React, {useState} from "react";
import {
    Create,
    FormTab,
    TextInput,
    TabbedForm,
    Toolbar,
    ReferenceInput,
    NumberInput, TextField, NumberField, Datagrid
} from 'react-admin';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from "@material-ui/core";
import SaveIcon from '@material-ui/icons/Save';
import ComboUnidadNegocio from "../componentes/ComboUnidadNegocio";


const useStyles = makeStyles((theme) => ({
    secuencia_tipo: {display: 'inline-block', width: 200, marginLeft: 8},
    secuencia_tipo_d: {display: 'inline-block', width: 800, marginLeft: 8},
}));

const PostCreateToolbar = props => {
    return (
        <Toolbar {...props} >

        </Toolbar>
    )

};

const validateCreate = (values) => {
    const errors = {};

    var w_secuencia_tipo = values.secuencia_tipo

    if (w_secuencia_tipo===undefined) {
        errors.secuencia_tipo = ['El campo Código es requerido'];
    }else {
        if (w_secuencia_tipo === null) {
            errors.secuencia_tipo = ['El campo Código es requerido'];
        } else {
            w_secuencia_tipo = w_secuencia_tipo.trim()
            if (w_secuencia_tipo === '') {
                errors.secuencia_tipo = ['El campo Código es requerido'];
            }
        }
    }


    var w_secuencia_tipo_d = values.secuencia_tipo_d

    if (w_secuencia_tipo_d===undefined) {
        errors.secuencia_tipo_d = ['El campo Descripción Contratacion Secuencia Tipo es requerido'];
    }else {
        if (w_secuencia_tipo_d === null) {
            errors.secuencia_tipo_d = ['El campo Descripción Contratacion Secuencia Tipo es requerido'];
        } else {
            w_secuencia_tipo_d = w_secuencia_tipo_d.trim()
            if (w_secuencia_tipo_d === '') {
                errors.secuencia_tipo_d = ['El campo Descripción Contratacion Secuencia Tipo es requerido'];
            }
        }
    }




    return errors
};

// redirect to the related Author show page
const redirect = (basePath, id, data) => `/UnidadEmisora`;

const ContratacionSecuenciaTipoCreate = props => {
    const classes = useStyles();

    const PostTitle = ({record}) => {
        return <span>Alta de Contratacion Secuencia Tipo</span>;
    };

    return (
        <Create title={<PostTitle/>} {...props}>
            <TabbedForm
                // toolbar={<PostCreateToolbar />} validate={validateCreate} redirect={redirect}
            >
                {/*Datos*/}
                <FormTab label="DATOS CONTRATACION SECUENCIA TIPO">
                    <TextInput
                        label="Código Contratacion Secuencia Tipo"
                        source="secuencia_tipo"
                        formClassName={classes.secuencia_tipo}
                        placeholder="Ingrese Código Contratacion Secuencia Tipo"
                        helperText="Código Contratacion Secuencia Tipo"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />
                    <br/>

                    <TextInput
                        label="Descripción Contratacion Secuencia Tipo"
                        source="secuencia_tipo_d"
                        formClassName={classes.secuencia_tipo_d}
                        placeholder="Ingrese Descripción Contratacion Secuencia Tipo"
                        helperText="Descripción Contratacion Secuencia Tipo"
                        margin="normal"
                        fullWidth={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />
                    <br/>



                </FormTab>
            </TabbedForm>
        </Create>
    )
};
export default ContratacionSecuenciaTipoCreate;


